module.exports = __webpack_public_path__ + "img/astral_4.16bf9ab8.svg";